"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var containerElementOptions = ['section', 'aside', 'article', 'footer', 'header', 'div'];
var containerRoles = {
  footer: 'contentinfo',
  header: 'banner',
  aside: 'complementary'
};

var Container = function Container(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      containerId = _ref.containerId,
      dataTestId = _ref.dataTestId,
      element = _ref.element,
      isFullHeight = _ref.isFullHeight,
      isFullWidth = _ref.isFullWidth,
      role = _ref.role,
      verticalSpacing = _ref.verticalSpacing;
  var ContainerTag = element;
  return /*#__PURE__*/_react.default.createElement(ContainerTag, {
    "data-testid": dataTestId,
    id: containerId,
    role: role || containerRoles[element],
    className: (0, _classnames.default)("container", _defineProperty({
      'container--full-width': isFullWidth,
      'container--full-height': isFullHeight
    }, "container-vertical-spacing--".concat(verticalSpacing), verticalSpacing), classes)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container__inner"
  }, children));
};

Container.propTypes = {
  /**
   Required. Containers must contain something.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,

  /**
   Optional. Custom Container classes.
   */
  classes: _propTypes.default.string,

  /**
   Optional. Custom id for top-level container element.
   */
  containerId: _propTypes.default.string,

  /**
   Optional, but recommended. Gives a unique identifier to the element which is useful for testing scenarios.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. HTML element: 'section', 'aside', 'article', 'footer', 'header', 'div'
   */
  element: _propTypes.default.oneOf(containerElementOptions),

  /**
   Optional. Optional. Defaults false.
   */
  isFullHeight: _propTypes.default.bool,

  /**
   Optional. Optional. Defaults false.
   */
  isFullWidth: _propTypes.default.bool,

  /**
   Optional. Sets element's <a href=" https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles">ARIA role</a>. The roles for header, footer, and aside are automatically set by the component.
   */
  role: _propTypes.default.oneOf(['alert', 'application', 'article', 'banner', 'button', 'cell', 'checkbox', 'comment', 'complementary', 'contentinfo', 'dialog', 'document', 'feed', 'figure', 'form', 'grid', 'gridcell', 'heading', 'img', 'list', 'listbox', 'listitem', 'main', 'mark', 'navigation', 'region', 'row', 'rowgroup', 'search', 'suggestion', 'switch', 'tab', 'table', 'tabpanel', 'textbox', 'timer']),

  /**
   Optional. Sets vertical padding: '0','10','20','30','40','50','60','70','80','90','100','110','120','130'
   */
  verticalSpacing: _propTypes.default.oneOf(['0', '10', '20', '30', '40', '50', '60', '70', '80', '90', '100', '110', '120', '130'])
};
Container.defaultProps = {
  classes: null,
  containerId: null,
  dataTestId: null,
  element: 'section',
  isFullHeight: false,
  isFullWidth: false,
  role: null,
  verticalSpacing: '60'
};
var _default = Container;
exports.default = _default;